// General Import
import {
  Component,
  HostListener,
  Input,
  OnInit,
  ViewChild
} from "@angular/core";
// Angular Material
import { MatDialog } from "@angular/material/dialog";
import { MatMenuTrigger } from "@angular/material/menu";
// Service
import { TranslateService } from "@ngx-translate/core";
import { PartnerService } from "src/app/share/service/partner.service";
import { FaqKtmbDialogComponent } from "../../dashboard/faq-dialog/faq-ktmb-dialog/faq-ktmb-dialog.component";
// Component
import { MenuMobileComponent } from "../menu/menu-mobile/menu-mobile.component";
import { GuidesDialogComponent } from "src/app/dashboard/guides-dialog/guides-dialog.component";
import { FaqDialogComponent } from "src/app/dashboard/faq-dialog/faq-dialog.component";
import { FaqTakafulDialogComponent } from "src/app/dashboard/faq-dialog/faq-takaful-dialog/faq-takaful-dialog.component";
import { ActivatedRoute, Router } from "@angular/router";
import { PartnerDataService } from "src/app/share/service/partnerData.service";
import { AuthService } from "src/app/share/service/auth.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})
export class AppHeaderComponent implements OnInit {
  partnerCode: string = "ps";
  showFAQ: Boolean = false;
  showFAQList: string[] = ["ps", "cbp", "ktmb", "foodpanda"];
  showWhatsappBtn: Boolean = true;

  showTranslationBtn: Boolean = true;
  hideTranslationBtnList: string[] = ["prolindung"];

  showGuideBtn: Boolean = true;
  hideGuideBtnList: string[] = ["foodpanda"];

  showLogoutBtn: boolean = false;
  showLogoutBtnList: string[] = ["prolindung"];

  @Input() state = ""; // decorate the property with @Input()
  @ViewChild("menuTrigger") menuTrigger: MatMenuTrigger;

  @HostListener("window:scroll", []) onWindowScroll() {
    // do some stuff here when the window is scrolled
    const verticalOffset =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
  }

  constructor(
    public partnerDataService: PartnerDataService,
    public translate: TranslateService,
    private router: Router,
    private dialog: MatDialog,
    private partnerService: PartnerService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.getParams();
  }

  private async getParams() {
    this.partnerCode = await this.partnerService.getPartnerCode();

    if (this.partnerCode == "ctos") {
      let partner = this.partnerService.partnerList.find(
        (x) => x.code == this.partnerCode
      );
      this.partnerService.appendGtmScript(partner.gtmID);
      this.partnerService.appendHeaderScript(`<!-- BEGIN PLERDY CODE -->
      <script type="text/javascript" defer data-plerdy_code='1'>
      var _protocol="https:"==document.location.protocol?" https://":" http://";
      _site_hash_code = "93e87d8451fbf8a79fffee4e4da41f1d",_suid=25861, plerdyScript=document.createElement("script");
      plerdyScript.setAttribute("defer",""),plerdyScript.dataset.plerdymainscript="plerdymainscript",
      plerdyScript.src=https://a.plerdy.com/public/js/click/main.js?v=+Math.random();
      var plerdymainscript=document.querySelector("[data-plerdymainscript='plerdymainscript']");
      plerdymainscript&&plerdymainscript.parentNode.removeChild(plerdymainscript);
      try{document.head.appendChild(plerdyScript)}catch(t){console.log(t,"unable add script tag")}
      </script>
      <!-- END PLERDY CODE -->`);
    }
    !this.partnerCode ? (this.partnerCode = "ps") : null;
    if (this.showFAQList.includes(this.partnerCode)) {
      this.showFAQ = true;
    }

    if (this.hideTranslationBtnList.includes(this.partnerCode)) {
      this.showTranslationBtn = false;
    }

    if (this.hideGuideBtnList.includes(this.partnerCode)) {
      this.showGuideBtn = false;
    }

    const isReviewApplicationLogin = this.router.url.includes('review-application') && this.router.url.includes('login');
    const isforgotPassword = this.router.url.includes('forgot-password')
    if (this.showLogoutBtnList.includes(this.partnerCode) && !isReviewApplicationLogin && this.router.url.includes('review-application') && !isforgotPassword) {
      this.showLogoutBtn = true;
      this.showFAQ = false;
      this.showWhatsappBtn = false;
      this.showGuideBtn = false;
    }
    if (isReviewApplicationLogin) {
      this.showFAQ = false;
      this.showWhatsappBtn = false;
      this.showGuideBtn = false;
    }

    if (this.partnerCode == "prolindung") {
      const currentUrl = this.router.url;
      if (currentUrl.includes("customer-form")) {
        this.showWhatsappBtn = false;
        this.showGuideBtn = false;
      }
    }

    if (
      ["foodpanda", "grab", "lalamove", "prolindung"].includes(this.partnerCode)
    ) {
      this.translate.use("bm");
    }
  }

  openMenu() {
    this.dialog.open(MenuMobileComponent, {
      panelClass: "menu-dialog",
      backdropClass: "menu-blackdrop",
      disableClose: true
    });
  }
  switch(lang: string) {
    if (lang == "en") {
      this.router.navigate([], {
        queryParams: { lang: lang },
        queryParamsHandling: "merge", // keeps existing params
        replaceUrl: true // optional: avoids adding to browser history
      });
    } else {
      this.router.navigate([], {
        queryParams: { lang: null },
        queryParamsHandling: "merge"
      });
    }

    this.translate.use(lang);
  }

  guideDialog() {
    this.dialog.open(GuidesDialogComponent, {
      panelClass: "guide-dialog"
    });
  }

  faqDialog() {
    if (this.partnerCode === "ktmb") {
      this.dialog.open(FaqKtmbDialogComponent, {
        autoFocus: false,
        disableClose: true,
        maxWidth: 600,
        panelClass: "ktmb-dialog",
        width: "100%"
      });
      return;
    }

    if (this.partnerService.getPartnerAttribute(this.partnerCode, "takaful")) {
      this.dialog.open(FaqTakafulDialogComponent, {
        panelClass: "faq-dialog"
      });
    } else {
      this.dialog.open(FaqDialogComponent, {
        panelClass: "faq-dialog"
      });
    }
  }

  logout() {
    this.authService.logout()
  }

  whatsppRedirect() {
    //B2C
    if (!this.partnerCode) {
      const whatsappNumber = 60182822320;
      const entityName = "Policystreet";
      let whatsappContent = "";
      let lang = this.translate.currentLang == "en" ? "en" : "ms";
      whatsappContent =
        lang == "ms"
          ? `Hai ${entityName}, saya ingin tahu dengan lebih lanjut mengenai cukai jalan dan insurans kenderaan`
          : `Hi ${entityName}, I would like to know more about road tax and car insurance`;

      let url = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(
        whatsappContent
      )}&source=&data=&app_absent=&lang=${lang}`;

      window.open(url, "_blank");
    }

    //affiliates
    if (
      this.partnerCode &&
      this.partnerDataService.partnerDetail.enableWhatsapp && this.partnerCode != "prolindung"
    ) {
      const whatsappNumber =
        this.partnerDataService.partnerDetail.whatsappMobileNo;
      const entityName = this.partnerDataService.partnerDetail.whatsappName;
      let whatsappContent = "";
      let lang = this.translate.currentLang == "en" ? "en" : "ms";
      whatsappContent =
        lang == "ms"
          ? `Hai ${entityName}, saya ingin tahu dengan lebih lanjut mengenai cukai jalan dan insurans kenderaan`
          : `Hi ${entityName}, I would like to know more about road tax and car insurance`;

      let url = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(
        whatsappContent
      )}&source=&data=&app_absent=&lang=${lang}`;

      window.open(url, "_blank");
    }
    else {
      const whatsappNumber = 60123975965;
      const entityName = "Prolindung";
      let whatsappContent = "";
      let lang = this.translate.currentLang == "en" ? "en" : "ms";
      whatsappContent =
        lang == "ms"
          ? `Hai ${entityName}, saya ingin tahu dengan lebih lanjut mengenai cukai jalan dan insurans kenderaan`
          : `Hi ${entityName}, I would like to know more about road tax and car insurance`;

      let url = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(
        whatsappContent
      )}&source=&data=&app_absent=&lang=${lang}`;

      window.open(url, "_blank");
    }
  }
}
